import React, { Fragment, memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import LOG from '../logging/Logger'

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(0, 2, 2, 2),
    margin: theme.spacing(0, 1, 0, 1),
    fontSize: '0.9rem',
    lineHeight: 1.4,
    color: '#999'
  }
}))

const InfoDialog = memo(({ onClose, selectedValue, open, content }) => {
  LOG.debug('Render: InfoDialog')

  const classes = useStyles()

  const handleClose = useCallback(() => {
    onClose(selectedValue)
  }, [onClose, selectedValue])

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='simple-dialog-title'
      open={open}
    >
      {Array.isArray(content) ? (
        content.map((item, i) => {
          return (
            <Fragment key={i}>
              <DialogTitle id='simple-dialog-title'>{item.title}</DialogTitle>
              <Typography className={classes.typography}>
                <b>{item.subTitle}</b>
                <br />
                {item.body}
              </Typography>
            </Fragment>
          )
        })
      ) : (
        <Fragment>
          <DialogTitle id='simple-dialog-title'>{content.title}</DialogTitle>
          <Typography className={classes.typography}>
            <b>{content.subTitle}</b>
            <br />
            {content.body}
          </Typography>
        </Fragment>
      )}
    </Dialog>
  )
})

InfoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.array.isRequired
  ])
}

const InfoItem = memo(props => {
  LOG.debug('Render: InfoItem')

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <IconButton
        color='primary'
        aria-label='upload picture'
        component='span'
        onClick={props.onClick}
      >
        <InfoOutlinedIcon />
      </IconButton>
      <InfoDialog
        open={props.open}
        onClose={props.onClose}
        title={props.title}
        content={props.content}
      />
    </div>
  )
})

export default InfoItem
